import React, { useState } from 'react';
import '../../assets/css/quote.css';

const YourQuote = () => {
  const [quantity, setQuantity] = useState(0);
  const [note, setNote] = useState('');
  const minQuantity = 6;
  const unitPrice = 10;
  const originalPrice = 20;

  const subtotal = quantity * unitPrice;
  const isQuantityValid = quantity >= minQuantity;

  const handleQuantityChange = (e) => {
    const value = parseInt(e.target.value) || 0;
    setQuantity(Math.max(0, value));
  };

  const handleAddToCart = () => {
    if (isQuantityValid) {
      alert(`Added ${quantity} items to cart!\nNote: ${note || 'No note'}`);
      // Add your cart logic here
    } else {
      alert(`Please add at least ${minQuantity} items`);
    }
  };

  return (
    <div className="quote-container">
      <h1 className="quote-title">Your Quote</h1>

      {/* Quantity Section */}
      <div className="quote-card">
        <h3 className="card-label">Quantity</h3>
        <input
          type="number"
          min="0"
          value={quantity}
          onChange={handleQuantityChange}
          className="quantity-input"
        />
        {!isQuantityValid && quantity > 0 && (
          <p className="error-message">
            A minimum quantity of {minQuantity} is required.
          </p>
        )}
        {quantity === 0 && (
          <p className="error-message">
            A minimum quantity of {minQuantity} is required.
          </p>
        )}
      </div>

      {/* Unit Price Section */}
      <div className="quote-card">
        <h3 className="card-label">Unit Price</h3>
        <div className="price-container">
          <span className="current-price">${unitPrice}</span>
          <span className="original-price">${originalPrice}</span>
        </div>
      </div>

      {/* Sub Total Section */}
      <div className="quote-card">
        <h3 className="card-label">Sub Total</h3>
        <span className="subtotal-price">${subtotal}</span>
      </div>

      {/* Note Section */}
      <div className="note-section">
        <label className="note-label">Note</label>
        <textarea
          value={note}
          onChange={(e) => setNote(e.target.value)}
          className="note-textarea"
          placeholder="Add any special instructions or notes..."
        ></textarea>
      </div>

      {/* Add to Cart Button */}
      <button
        onClick={handleAddToCart}
        className={`add-to-cart-btn ${isQuantityValid ? 'active' : 'disabled'}`}
        disabled={!isQuantityValid}
      >
        Add to Cart
      </button>
    </div>
  );
};

export default YourQuote;
